<template>
   <v-tooltip top open-delay='500'>
      <template v-slot:activator='{ on }'>
        <div v-on='on' class='d-inline-block'>
        <v-btn icon small @click='filter()' :disabled="disabled">
            <v-icon :color='active ? active_color : ""'>
            {{active ? icon_active : icon}}
            </v-icon>
        </v-btn>
        </div>
      </template>
      <span>{{text}}</span>
    </v-tooltip>
</template>
<script>
  export default {
    name: 'staging-table-icon',
    data() {
      return {
        active: this.disabled
      };
    },
    props: {
        icon: {
            required: true,
            type: String
        },
        icon_active: {
            required: true,
            type: String
        },
        active_color: {
            required: true,
            type: String
        },
        text: {
            required: true,
            type: String
        },
        disabled: {
            required: false,
            default: false,
            type: Boolean
        }
    },
    methods: {
      filter(){
          this.active = !this.active;
          this.$emit('filter', this.active);
      }
    }
}
</script>
